import { render } from "./CanxuanCommodityHotGoods.vue?vue&type=template&id=f4875fca"
import script from "./CanxuanCommodityHotGoods.vue?vue&type=script&lang=js"
export * from "./CanxuanCommodityHotGoods.vue?vue&type=script&lang=js"

import "./CanxuanCommodityHotGoods.vue?vue&type=style&index=0&id=f4875fca&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__